var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "distribut" },
    [
      _c(
        "v-expansion-panels",
        [
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", [
                _c("h4", { staticClass: "distribut__small-title" }, [
                  _vm._v("Развернуть список"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "v-expansion-panel-content",
                _vm._l(_vm.items, function (item) {
                  return _c("div", { staticClass: "distribut__inner" }, [
                    _c("div", { staticClass: "distribut__container" }, [
                      _c("span", { staticClass: "distribut__name" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "distribut__contact" }, [
                        _c("div", { staticClass: "distribut__call copyEl" }, [
                          _c(
                            "a",
                            {
                              staticClass: "link distribut__link",
                              attrs: { href: "tel:" + item.tel },
                            },
                            [_vm._v(_vm._s(item.tel))]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "copyData" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "32",
                                  height: "32",
                                  viewBox: "0 0 32 32",
                                  fill: "none",
                                  stroke: "#C0C0C0",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M25.3334 9.3335H13.3334C11.8607 9.3335 10.6667 10.5274 10.6667 12.0002V24.0002C10.6667 25.4729 11.8607 26.6668 13.3334 26.6668H25.3334C26.8062 26.6668 28.0001 25.4729 28.0001 24.0002V12.0002C28.0001 10.5274 26.8062 9.3335 25.3334 9.3335Z",
                                    stroke: "inherit",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "M9.33325 21.3333H7.99992C7.29267 21.3333 6.6144 21.0524 6.1143 20.5523C5.6142 20.0522 5.33325 19.3739 5.33325 18.6667V6.66667C5.33325 5.95942 5.6142 5.28115 6.1143 4.78105C6.6144 4.28095 7.29267 4 7.99992 4H19.9999C20.7072 4 21.3854 4.28095 21.8855 4.78105C22.3856 5.28115 22.6666 5.95942 22.6666 6.66667V8",
                                    stroke: "inherit",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "distribut__mail copyEl" }, [
                          _c(
                            "a",
                            {
                              staticClass: "link distribut__link",
                              attrs: { href: "mailto:" + item.email },
                            },
                            [_vm._v(_vm._s(item.email))]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "copyData" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "32",
                                  height: "32",
                                  viewBox: "0 0 32 32",
                                  fill: "none",
                                  stroke: "#C0C0C0",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M25.3334 9.3335H13.3334C11.8607 9.3335 10.6667 10.5274 10.6667 12.0002V24.0002C10.6667 25.4729 11.8607 26.6668 13.3334 26.6668H25.3334C26.8062 26.6668 28.0001 25.4729 28.0001 24.0002V12.0002C28.0001 10.5274 26.8062 9.3335 25.3334 9.3335Z",
                                    stroke: "inherit",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "M9.33325 21.3333H7.99992C7.29267 21.3333 6.6144 21.0524 6.1143 20.5523C5.6142 20.0522 5.33325 19.3739 5.33325 18.6667V6.66667C5.33325 5.95942 5.6142 5.28115 6.1143 4.78105C6.6144 4.28095 7.29267 4 7.99992 4H19.9999C20.7072 4 21.3854 4.28095 21.8855 4.78105C22.3856 5.28115 22.6666 5.95942 22.6666 6.66667V8",
                                    stroke: "inherit",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "distribut__site copyEl" }, [
                          _c(
                            "a",
                            {
                              staticClass: "link distribut__link",
                              attrs: {
                                href: "https://" + item.website,
                                target: "_blank",
                              },
                            },
                            [_vm._v(_vm._s(item.website))]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "copyData" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "32",
                                  height: "32",
                                  viewBox: "0 0 32 32",
                                  fill: "none",
                                  stroke: "#C0C0C0",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M25.3334 9.3335H13.3334C11.8607 9.3335 10.6667 10.5274 10.6667 12.0002V24.0002C10.6667 25.4729 11.8607 26.6668 13.3334 26.6668H25.3334C26.8062 26.6668 28.0001 25.4729 28.0001 24.0002V12.0002C28.0001 10.5274 26.8062 9.3335 25.3334 9.3335Z",
                                    stroke: "inherit",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "M9.33325 21.3333H7.99992C7.29267 21.3333 6.6144 21.0524 6.1143 20.5523C5.6142 20.0522 5.33325 19.3739 5.33325 18.6667V6.66667C5.33325 5.95942 5.6142 5.28115 6.1143 4.78105C6.6144 4.28095 7.29267 4 7.99992 4H19.9999C20.7072 4 21.3854 4.28095 21.8855 4.78105C22.3856 5.28115 22.6666 5.95942 22.6666 6.66667V8",
                                    stroke: "inherit",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "distribut__data" }, [
                        _c("p", { staticClass: "distribut__subtext" }, [
                          _vm._v(
                            "ПН-ПТ: с 09-00 до 18-00 СБ-ВС:\n                                выходной"
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "distribut__subtext distribut__address",
                          },
                          [_vm._v(_vm._s(item.address))]
                        ),
                      ]),
                    ]),
                  ])
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }